/* ==========================================================================
  Review slider
========================================================================== */

"use strict";

/* global Swiper */

const initReviewSlider = () => {
  const reviewSliderEl = document.querySelector(".reviews-slider");

  if (!reviewSliderEl) {
    return;
  }

  new Swiper(".reviews-slider", {
    effect: "coverflow",
    grabCursor: true,
    centeredSlides: true,
    loop: true,
    slidesPerView: "auto",
    preventClicks: false,
    preventClicksPropagation: false,
    lazyLoadingInPrevNext: true,
    autoplay: true,
    navigation: false,
    navigation: {
      nextEl: ".reviews-slider__controls--next",
      prevEl: ".reviews-slider__controls--prev",
    },
    coverflowEffect: {
      rotate: 0,
      stretch: 1,
      depth: 40,
      modifier: -16,
      slideShadows : false
    }
  });
};

document.addEventListener("DOMContentLoaded", () => {
  initReviewSlider();
});
